module.exports = __webpack_public_path__ + "img/suggestion.c827ad72.svg";